import BaseAPI from "./BaseAPI";

class DossierAPI extends BaseAPI {
	
    index = () => {
        var promise = this.init().post("/account/dossiers", {});
        return promise;
    };

    getWorkprocesses = () => {
        var promise = this.init().post("/account/wp/search", {});
        return promise;
    };

    initDossier = (data) => {
        var promise = this.init().get("/account/dossiers/init/"+data.id);
        return promise;
    };
    
    
    createDossier = (data) => {
        var promise = this.init().post("/account/dossiers/create", data);
        return promise;
    };

    searchDossiers = ($filter) => {
        var promise = this.init().post("/account/dossiers/search", $filter);
        return promise;
    };

    searchDossiersOn = ($filter) => {
        var promise = this.init().post("/account/dossiers/searchOn", $filter);
        return promise;
    };

    get = (data) => {
        var promise = this.init().get("/account/dossiers/"+data?.key);
        return promise;
    };

    store = (data) => {
        var promise = this.init().post("/account/dossier", data);
        return promise;
    };

    quickSearch = (data) => {
        var promise = this.init().post("/account/dossiers/quickSearch", data);
        return promise;
    };

    storeWorklog = (data) => {
        let key = data.dossierKey.trim();
        
        var promise = this.init().post("/account/dossier/"+key+"/worklog", data);
        return promise;
    };
    
    closeTask = (data) => {
        let key = data.dossierKey.trim();
        
        var promise = this.init().post("/account/dossier/"+key+"/close", data);
        return promise;
    };

    getAllDescriptions = (data) => {
        let key = data.dossier_key.trim();
        var promise = this.init().post("/account/dossier/"+key+"/getDescriptions", data);
        return promise;
    };
    
    
    storeSchedule = (data) => {
        let key = data.dossierKey.trim();
        
        var promise = this.init().post("/account/dossiers/"+key+"/storeSchedule", data);
        return promise;
    };
	
}

export default new DossierAPI();